// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';
import type { OptionTypeBase } from 'react-select';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

const {
  white,
  baseDark,
  baseLight,
  baseLighterDarkMode,
  baseMain,
  baseLighter,
  primaryLighter,
  grayLight,
  primaryLight,
  grayDark,
  grayMain,
  secondaryLight,
} = colors;

export const lightMode = {
  control: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: white,
    borderColor: grayDark,
    ':focus': {
      border: grayDark,
    },
    borderRadius: 5,
    minHeight: 56,
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: 'none',
    fontFamily:
      'Nunito, SF Pro Display, -apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    ':hover': {
      borderColor: primaryLight,
    },
  }),
  input: (styles: OptionTypeBase) => ({
    ...styles,
    color: baseMain,
  }),
  clearIndicator: (styles: OptionTypeBase) => ({ ...styles, color: baseMain }),
  dropdownIndicator: (styles: OptionTypeBase) => ({
    ...styles,
    color: baseMain,
    padding: 16,
  }),
  option: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: white,
    ':hover': {
      backgroundColor: grayLight,
    },
  }),
  placeholder: (styles: OptionTypeBase) => ({
    ...styles,
    fontFamily:
      'Nunito, SF Pro Display, -apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    padding: 16,
  }),
  multiValue: (styles: OptionTypeBase) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderColor: grayMain,
    borderRadius: 30,
    minHeight: 36,
    borderWidth: 1,
    borderStyle: 'solid',
    paddingLeft: 8,
    paddingRight: 8,
  }),
  multiValueLabel: (styles: OptionTypeBase) => ({
    ...styles,
    padding: 0,
  }),
  multiValueRemove: (styles: OptionTypeBase) => ({
    ...styles,
    borderRadius: '100%',
    width: 16,
    height: 16,
    color: baseMain,
    justifyContent: 'center',
    padding: 0,
    ':hover': {
      color: white,
      backgroundColor: baseLight,
      cursor: 'pointer',
    },
    svg: {
      width: 16,
      height: 16,
    },
  }),
};

export const darkMode = {
  control: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: baseLighterDarkMode,
    borderColor: 'transparent',
    ':focus': {
      border: primaryLighter,
    },
    borderRadius: 5,
    minHeight: 56,
    borderWidth: 1,
    borderStyle: 'solid',
    boxShadow: 'none',
    fontFamily:
      'Nunito, SF Pro Display, -apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    ':hover': {
      borderColor: primaryLight,
    },
  }),
  menuList: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: baseLighterDarkMode,
  }),
  input: (styles: OptionTypeBase) => ({
    ...styles,
    color: white,
  }),
  clearIndicator: (styles: OptionTypeBase) => ({ ...styles, color: white }),
  dropdownIndicator: (styles: OptionTypeBase) => ({
    ...styles,
    color: white,
    padding: 16,
  }),
  option: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: baseLighterDarkMode,
    ':hover': {
      backgroundColor: baseMain,
    },
  }),
  placeholder: (styles: OptionTypeBase) => ({
    ...styles,
    fontFamily:
      'Nunito, SF Pro Display, -apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    padding: 16,
  }),
  valueContainer: (styles: OptionTypeBase) => ({
    ...styles,
    backgroundColor: 'transparent',
  }),
  multiValue: (styles: OptionTypeBase) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderColor: baseLighter,
    color: grayMain,
    borderRadius: 30,
    minHeight: 36,
    borderWidth: 1,
    borderStyle: 'solid',
    paddingLeft: 8,
    paddingRight: 8,
  }),
  multiValueLabel: (styles: OptionTypeBase) => ({
    ...styles,
    padding: 0,
  }),
  multiValueRemove: (styles: OptionTypeBase) => ({
    ...styles,
    borderRadius: '100%',
    width: 16,
    height: 16,
    color: secondaryLight,
    justifyContent: 'center',
    padding: 0,
    ':hover': {
      color: baseDark,
      backgroundColor: secondaryLight,
      cursor: 'pointer',
    },
    svg: {
      width: 16,
      height: 16,
    },
  }),
};

export const WrapperMessages = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };
    padding: 24px 12px;
    color: ${
      isDark ? theme.colors.white : theme.colors.base['light-dark-mode']
    };
  `,
);
